import { HTTPClient } from '../utils/request'

export default {
  refreshToken: (payload) => HTTPClient.post('/Login/RefreshToken', payload)
}
